<template>
<div>
  <v-toolbar flat>
    <div class="nav_wrapper">
      
      <div class="nav_left">
        <v-app-bar-nav-icon class="hidden-sm-and-down" @click="showMenu"><v-icon v-if="!mini">mdi-format-indent-decrease</v-icon><v-icon v-else>mdi-format-indent-increase</v-icon></v-app-bar-nav-icon>
        <v-app-bar-nav-icon class="d-md-none" @click="showMenu1"></v-app-bar-nav-icon>
                      <div class="left_sides_analy"  style="margin-left:20px;">
                      </div>
           <div class="alert_iprbd" @click="goback_iprbd">
            <div class="goback_iprbd"></div>
            <span class="title">返回旧版</span>
          </div>
           <div class="alert_bell" @click="alertChange">
              <div class="bell_icon"></div>
              <span class="red_point" v-if="redPoint"></span>
          </div>
      </div>
      <div class="nav_right">
        <div class="flex_style right">
          <div class="user_img hidden-xs-only">
            <!-- <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img> -->
            <img src="../../assets/images/common/default_user.svg" alt="">
          </div>
          <div class="user_name">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div
                  plain
                  v-bind="attrs"
                  v-on="on"
                >
                  <div class="user_img d-sm-none">
                    <!-- <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img> -->
                    <img src="../../assets/images/common/default_user.svg" alt="">
                  </div>
                  <!-- <span class="text tit_overflow hidden-xs-only">上海美维电子有限公司</span> -->
                  <v-icon class="hidden-xs-only">mdi-chevron-down</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item-group v-model="userSel">
                  <v-list-item>
                    <v-list-item-title>{{ userInfo.nickName }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-for="(item, index) in userItems"
                    :key="index"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div>  
  </v-toolbar>
    <v-dialog
      v-model="alertDialog"
      :fullscreen="true"
      content-class="alert_msg_dialog">
      <div class="alert_msg_wrapper">
          <div class="tit_name">消息通知</div>
          <div class="close_btn" @click="alertDialog = false"></div>
          <div v-if="msgList&&msgList.length>0">
            <div v-show="step == 1">
              <div class="flex_style right marb10">
                <div class="right_btn" @click="readAll">全部标记已读</div>
              </div>
              <div class="table_list_wrapper">
                <v-data-table
                    :headers="msgHeader"
                    :items="msgList"
                    disable-pagination
                    hide-default-header
                    hide-default-footer
                    no-data-text="暂无数据"
                    class="common_table">
                        <template v-slot:item="{item}">
                            <div class="line_style hand" @click="goDetail(item)">
                                <div class="td1">
                                    <div class="tag" v-if="item.msgType=='专利管家年费监控'">年费监控</div>
                                    <div class="tag" v-else>{{item.msgType}}</div>
                                    <div class="text" v-if="item.hasRead">{{item.title}}</div>
                                    <div class="text_wrapper" v-else>
                                      <span class="icon"></span>
                                      <span class="text1">{{item.title}}</span>
                                    </div>
                                </div>
                                <!-- <div class="td2">{{item.updatedAt}}</div> -->
                                <div class="td2">{{item.strDate}}</div>

                            </div>
                        </template>
                </v-data-table>
                <div class="common_page">
                  <span class="text">共{{total}}条记录</span>
                  <v-pagination
                      v-model="currentPage"
                      :length="length"
                      :total-visible="7"
                      >
                  </v-pagination>
                </div>
              </div>
            </div>
            <div v-show="step == 2">
                <div class="back_nav_wrapper" @click="goListBack">
                  <v-icon>mdi-arrow-left</v-icon>
                  <div class="text">返回消息列表</div>
                </div>
                <div class="flex_style left">
                  <div class="detail_name1">
                    通知： {{detailInfo.title}}
                  </div>
                  <div class="detail_name2">{{timeFormat(detailInfo.updatedAt)}}</div>
                </div>
                <div class="detail_table_wrapper">
                    <div>
                        <!-- disable-pagination
                        hide-default-footer -->
                      <v-data-table
                        :headers="detailHeader"
                        :items="detailList"
                        no-data-text="暂无数据"
                        :items-per-page='10'
                        :footer-props="{
                            itemsPerPageAllText: '全部',
                            itemsPerPageText: '每页',
                            showCurrentPage: true,
                            itemsPerPageOptions: [5,10,15,20,-1],
                        }"
                        class="common_table">
                        <template v-slot:item="{index,headers,item}">
                            <tr>
                                <td class="text-start" v-for="(item1,index1) in headers" :key="index1">
                                    <div class="tit_overflow" v-if="item1.value == 'index'">
                                        {{index+1}}
                                    </div>
                                    <div class="tit_overflow" v-else-if="item1.value == 'status'">
                                        <div>
                                          <span v-if="item.monitorPatent.status=='NEW'">最新命中</span>
                                          <span v-else-if="item.monitorPatent.status=='UPDATING'">最新更新</span>
                                          <span v-else-if="item.monitorPatent.status=='PAYED'">已缴费</span>
                                          <span v-else-if="item.monitorPatent.status=='WAIT_PAYMENT'">待缴费</span>
                                          <span v-else-if="item.monitorPatent.status=='EMERGENT'">紧急</span>
                                          <span v-else-if="item.monitorPatent.status=='LATE'">滞纳</span>
                                          <span v-else-if="item.monitorPatent.status=='OVER'">超期</span>
                                          <span v-else-if="item.monitorPatent.status=='UNKNOWN'">未知</span>
                                          <span v-else>--</span>
                                        </div>
                                    </div>
                                    <div class="tit_overflow" v-else-if="item1.value == 'actions'">
                                        <div @click="getFees(item)">
                                            <span class="text_blue hand">费用明细</span>
                                        </div>
                                    </div>
                                    <div class="tit_overflow" v-else-if="item.monitorPatent">
                                        {{item.monitorPatent[item1.value]}}
                                    </div>
                                </td>
                            </tr>
                        </template>
                      </v-data-table>
                    </div>
                </div>
            </div>
          </div>
          <div v-else>
              <div class="msg_empty_wrapper">
                  <div class="img">
                    <img src="../../assets/images/icons/nomsg_icon.svg" alt="">
                  </div>
                  <div class="text">暂无消息通知</div>
              </div>
          </div>
      </div>
    </v-dialog>
    <v-dialog
        v-model="feeDialog"
        width="70%"
        >
        <v-card>
            <v-card-title><span class="fontbold font18">查询费用信息</span> <v-icon @click="handleFeeCancel">mdi-close</v-icon></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div>
                  <v-overlay
                      :absolute="absolute"
                      :value="feeLoading">
                      <v-progress-circular
                          indeterminate
                          size="64"
                      ></v-progress-circular>
                      <div class="white_color">正在获取费用明细，请耐心等待</div>
                  </v-overlay>
                <div class="addSpace_wrapper feeInfo_wrapper">
                    <div class="fee_top_wrapper marb20">
                        <div class="flex_style left marb6">
                            <div class="line_style_item">
                                <div class="label">费用信息查询时间：</div>
                                <div class="value" v-if="feeInfo.monitorDate">{{timeFormat(feeInfo.monitorDate)}}</div>
                            </div>
                            <div class="line_style_item">
                                <div class="label">专利号：</div>
                                <div class="value">{{feeInfo.documentNumber}}</div>
                            </div>
                        </div>
                        <div class="flex_style left">
                            <div class="line_style_item">
                                <div class="label">专利名称：</div>
                                <div class="value">{{feeInfo.title}}</div>
                            </div>
                            <div class="line_style_item">
                                <div class="label">法律状态：</div>
                                <div class="value">{{feeInfo.legalStatus}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="fee_center_wrapper">
                        <div class="tit_name">未缴费信息</div>
                        <div class="table_line_wrapper">
                            <div class="table_box">
                                <div class="tr header">
                                    <div class="td">费用种类</div>
                                    <div class="td">应缴金额（元）</div>
                                    <div class="td">缴费截止日</div>
                                    <div class="td">费用状态</div>
                                </div>
                                <div class="tr" v-for="(item,index) in feeData1" :key="index">
                                    <div class="td">{{item.feeType}}</div>
                                    <div class="td">{{item.amount}}</div>
                                    <div class="td">{{item.date}}</div>
                                    <div class="td" v-if="item.state">{{item.state}}</div>
                                    <div class="td" v-else>未知</div>
                                </div>
                            </div>
                        </div>
                        <div class="tit_name">已缴费信息</div>
                        <div class="table_line_wrapper">
                            <div class="table_box">
                                <div class="tr header">
                                    <div class="td">费用种类</div>
                                    <div class="td">应缴金额（元）</div>
                                    <div class="td">缴费截止日</div>
                                    <div class="td">费用状态</div>
                                </div>
                                <div class="tr" v-for="(item,index) in feeData2" :key="index">
                                    <div class="td">{{item.feeType}}</div>
                                    <div class="td">{{item.amount}}</div>
                                    <div class="td">{{item.date}}</div>
                                    <div class="td">已缴费</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </v-card-text>   
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
  export default {
    data: () => ({
      redPoint: false,
      absolute: true,
      feeLoading: false,
      isLoading: false,
      items: [],
      tab: null,
      userItems: [
        {
          title: '个人信息'
        },
        {
          title: '历史语句'
        },
        {
          title: '退出登录'
        }
      ],
      userSel: '',
      msgHeader:[],//添加的字段
      userInfo: '',
       alertDialog: false,
      step: 1,
      currentPage: 1,
      pageSize: 16,
      msgList: [],
      total: 0,
      length: 0,
      detailHeader: [],
      detailHeader4: [
        {
            text: '序号',
            align: 'start',
            sortable: false,
            value: 'index'
        },
        {
            text: '申请号',
            align: 'start',
            sortable: false,
            value: 'applicationNumber'
        },
        {
            text: '专利名称',
            align: 'start',
            sortable: false,
            value: 'title'
        },
        {
            text: '专利类型',
            align: 'start',
            sortable: false,
            value: 'patentType'
        },
        {
            text: '专利状态',
            align: 'start',
            sortable: false,
            value: 'currentStatus'
        },
        {
            text: '申请日',
            align: 'start',
            sortable: false,
            value: 'applicationDateString'
        },
        {
            text: '原专利权人',
            align: 'start',
            sortable: false,
            value: 'inventor'
        },
        {
            text: '专利权人',
            align: 'start',
            sortable: false,
            value: 'inventor'
        },
      ],
      detailHeader3: [
        {
            text: '序号',
            align: 'start',
            sortable: false,
            value: 'index'
        },
        {
            text: '申请号',
            align: 'start',
            sortable: false,
            value: 'applicationNumber'
        },
        {
            text: '专利名称',
            align: 'start',
            sortable: false,
            value: 'title'
        },
        {
            text: '当前状态',
            align: 'start',
            sortable: false,
            value: 'status'
        },
        {
            text: '申请人',
            align: 'start',
            sortable: false,
            value: 'applicant'
        },
        {
            text: '申请日',
            align: 'start',
            sortable: false,
            value: 'applicationDateString'
        },
        {
            text: '发明人',
            align: 'start',
            sortable: false,
            value: 'inventor'
        },
      ],
      detailHeader2: [
        {
            text: '序号',
            align: 'start',
            sortable: false,
            value: 'index'
        },
        {
            text: '申请号',
            align: 'start',
            sortable: false,
            value: 'applicationNumber'
        },
        {
            text: '专利名称',
            align: 'start',
            sortable: false,
            value: 'title'
        },
        {
            text: '专利类型',
            align: 'start',
            sortable: false,
            value: 'patentType'
        },
        {
            text: '专利状态',
            align: 'start',
            sortable: false,
            value: 'currentStatus'
        },
        {
            text: '申请人',
            align: 'start',
            sortable: false,
            value: 'applicant'
        },
        {
            text: '申请日',
            align: 'start',
            sortable: false,
            value: 'applicationDateString'
        },
        {
            text: '缴费截止日',
            align: 'start',
            sortable: false,
            value: 'deadlineString'
        },
        {
            text: '应缴费',
            align: 'start',
            sortable: false,
            value: 'fee'
        },
        {
            text: '监控操作',
            align: 'start',
            sortable: false,
            value: 'actions'
        },
      ],
      detailHeader1: [
        {
            text: '序号',
            align: 'start',
            sortable: false,
            value: 'index'
        },
        {
            text: '申请号',
            align: 'start',
            sortable: false,
            value: 'applicationNumber'
        },
        {
            text: '专利名称',
            align: 'start',
            sortable: false,
            value: 'title'
        },
        {
            text: '专利类型',
            align: 'start',
            sortable: false,
            value: 'patentType'
        },
        {
            text: '专利状态',
            align: 'start',
            sortable: false,
            value: 'currentStatus'
        },
        {
            text: '申请人',
            align: 'start',
            sortable: false,
            value: 'applicant'
        },
        {
            text: '申请日',
            align: 'start',
            sortable: false,
            value: 'applicationDateString'
        },
        {
            text: '发明人',
            align: 'start',
            sortable: false,
            value: 'inventor'
        },
      ],
      detailInfo: {},
      detailList: [],
      feeData1: [],
      feeData2: [],
      feeInfo: {},
      feeDialog: false,
      timer: ''
    }),
    computed: {
      mini() {
        return this.$store.state.mini
      }
    },
    mounted() {
      this.getUserInfo()
      this.getMessageList()
      this.currentPage = 1
      this.timer = setInterval(()=>{
        this.getMessageList()
      },60000)
    },
    destroyed() {
      clearInterval(this.timer)
    },
    watch: {
      userSel(val) {
        if(val == '3') {
          this.goOut()
        }
        if(val == '2') {
          this.$router.push({
            path: '/user/history'
          })
        }
        if(val == '1') {
          this.$router.push({
            path: '/user/baseData'
          })
        }
      }
    },
    methods: {
      ...mapActions('common',['logOut']),
      ...mapActions('user',['personalInfo']),
       ...mapActions('manager',['getNotiMsgList','getNotiMsgDetail','readNotiMsg','annualFeeInfo']),
      getUserInfo() {
        let _this = this
        let data = {
            params: {
                tag: 'user_info'
            }
        }
        this.personalInfo({data: data,handle(res) {
            let info = res.user
            _this.userInfo = info
        }})
      },
      showMenu() {
        this.$store.commit('setMenuDraw', true)
        this.$store.commit('setMenuMini', !this.mini)
      },
      showMenu1() {
        this.$store.commit('setMenuMini', true)
      },
      goLogin() {
        this.$router.push({
          path: '/login'
        })
      },
      goOut() {
        let _this = this
        this.logOut({handle(res) {
          console.log('res', res)
            _this.$router.push({
              path: '/'
            })
        }})
      },
      goback_iprbd(){
        window.location.href="https://www.iprdb.com" 

      },
      alertChange() {
        this.alertDialog = true
        this.getMessageList()
        this.step = 1
      },
      getMessageList() {
        this.redPoint = false  
        let data = {
          params: {
            p: this.currentPage,
            pageSize: this.pageSize
          }
        }
        let _this = this
        this.getNotiMsgList({data: data,handle(res) {
           let list = res.pagination.data
            if(list&&list.length>0) {
              list.forEach((item)=>{
                if(!item.hasRead) {
                  _this.redPoint = true
                }
              })
            }
            _this.msgList = res.pagination.data
            _this.total = res.pagination.total
            _this.length = res.pagination.totalPages
        }})
      },
      goListBack() {
        this.step = 1
        this.getMessageList()
      },
      readAll() {
        let data = {}
        let _this = this
        this.readNotiMsg({data: data,handle(res) {
            if(res.success) {
              _this.$message({
                type: 'success',
                message: res.message
              })
              _this.getMessageList()
            }else {
              _this.$message({
                type: 'info',
                message: res.message
              })
            }
        }}) 
      },
      goDetail(val) {
          if(val.type == 'ASSISTANT_NEW') {
            this.detailHeader = this.detailHeader1
          }else if(val.type == 'ASSISTANT_FEE') {
            this.detailHeader = this.detailHeader2
          }else if(val.type == 'ASSISTANT_STATUS') {
            this.detailHeader = this.detailHeader3
          }else {
            this.detailHeader = this.detailHeader4
          }
          this.detailInfo = val
          this.step = 2
          let data = {
            params: {
              id: val.id,
              t: val.type
            }
          }
          let _this = this
          this.getNotiMsgDetail({data: data,handle(res) {
            if(res.contentList) {
              _this.detailList = res.contentList
            }else {
              _this.detailList = res.contentMap.NEW || res.contentMap.UPDATING || res.contentMap.PAYED
              ||res.contentMap.WAIT_PAYMENT || res.contentMap.EMERGENT || res.contentMap.LATE || res.contentMap.OVER || res.contentMap.UNKNOWN 
            }
              
              _this.detailInfo = res.bean
          }})
      },
      getFees(val) {
          this.feeData1 = []
          this.feeData2 = []
          this.feeInfo = val.monitorPatent
          this.feeDialog = true
          console.log('val', val)
          let data = {
              params: {
                  applicationNumber: val.monitorPatent.applicationNumber
              }
          }
          this.feeLoading = true
          let _this = this
            this.annualFeeInfo({data: data,handle(res) {
                _this.feeLoading = false
                if(res.code == '0') {
                    let list = JSON.parse(res.FeeInfo)
                    let data1 = [] 
                    list.forEach((item)=>{
                        if(item.type == '应缴费信息') {
                            data1.push(item)
                        }
                    })
                    data1.sort((a,b)=>{
                        return new Date(a.date).getTime() - new Date(b.date).getTime()
                    })
                    let data2 = []
                    list.forEach((item)=>{
                        if(item.type == '已缴费信息') {
                            data2.push(item)
                        }
                    })
                    data2.sort((a,b)=>{
                        return new Date(a.date).getTime() - new Date(b.date).getTime()
                    })
                    _this.feeData1 = data1
                    _this.feeData2 = data2
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    })
                }
            }})
      },
      handleFeeCancel() {
          this.feeDialog = false
      },
      timeFormat(unixTime) {
        let date = new Date(unixTime);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
        return Y+M+D;
      },
    }
  }
</script>